package com.yet.tetris.database

import app.cash.sqldelight.ColumnAdapter
import com.yet.tetris.domain.model.game.TetrominoType
import kotlin.Long
import kotlin.String

public data class BoardCells(
  public val positionX: Long,
  public val positionY: Long,
  public val pieceType: TetrominoType,
) {
  public class Adapter(
    public val pieceTypeAdapter: ColumnAdapter<TetrominoType, String>,
  )
}
